// extracted by mini-css-extract-plugin
export default {"wrapper":"Wrapper_wrapper__HLPWk","logo":"Wrapper_logo__85nbH","content":"Wrapper_content__O22Io"};